import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "zones-announcement t-text",
  "data-qe-id": "zones-announcement"
}
const _hoisted_2 = ["innerHTML"]

import { marked } from 'marked'

export default /*@__PURE__*/_defineComponent({
  __name: 'CZoneAnnouncement',
  props: {
    announcementId: {}
  },
  setup(__props: any) {

// Info announcement section on top of the zone selection page


function md(text: string) {
  return marked(text)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "text",
      innerHTML: md(_ctx.$t(`announcements.announcement.${_ctx.announcementId}`))
    }, null, 8, _hoisted_2)
  ]))
}
}

})